import { configureStore } from "@reduxjs/toolkit";
import { reducer as userReducer } from "~/modules/user/store";
import { reducer as searchReducer } from "~/modules/search/store";
import { reducer as toasterReducer } from "~/modules/toaster/store";
import { reducer as debugReducer } from "~/modules/debug/store";
import { reducer as authReducer } from "~/modules/auth/store";
import { reducer as catalogReducer } from "~/modules/catalog/store";
import { reducer as assetChatReducer } from "~/modules/asset_chat/store";

// // // //

/**
 * The Redux store object for the application.
 * NOTE - all new store interfaces must be registers here and in ReduxProvider/types.ts
 *
 * @typedef {Object} Store
 * @property {Function} dispatch - The Redux store's dispatch method.
 * @property {Function} getState - The Redux store's getState method.
 * @property {Function} subscribe - The Redux store's subscribe method.
 * @property {Function} replaceReducer - The Redux store's replaceReducer method.
 */
export const store = configureStore({
    reducer: {
        user: userReducer,
        search: searchReducer,
        toaster: toasterReducer,
        debug: debugReducer,
        auth: authReducer,
        catalog: catalogReducer,
        assetChat: assetChatReducer,
    },
});
